import { Outlet } from "react-router-dom";
import styles from "./styles.module.css";
import BgImg from "../../../images/waiter_bg.webp";

function PopupLayout() {
  return (
    <div className={styles.container}>
      <div className={styles.left}>
        <div className={styles.imageCard}>
          <img src={BgImg} className={styles.cashierImg} alt="background" />
        </div>
      </div>
      <div className={styles.right}>
        <div className={styles.card}>
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default PopupLayout;
